module.exports = __webpack_public_path__ + "img/icon-note-light-white.e72e68ec.svg";